export enum RedeemableCodeId {
    exampleCode = "example-code"
}
